import { Minus, Plus } from "lucide-react";

export function Stepper({ value, onChange, min = 0, max = 99, testid }) {
  return (
    <div className="inline-flex items-center rounded-full border border-border bg-white" data-testid={testid}>
      <button type="button" aria-label="Disminuir" data-testid={`${testid}-minus`} disabled={value <= min}
        onClick={() => onChange(Math.max(min, value - 1))}
        className="h-10 w-10 grid place-items-center rounded-full text-primary transition-colors hover:bg-accent disabled:opacity-30">
        <Minus className="h-4 w-4" />
      </button>
      <span className="w-8 text-center font-semibold tabular-nums" data-testid={`${testid}-value`}>{value}</span>
      <button type="button" aria-label="Aumentar" data-testid={`${testid}-plus`} disabled={value >= max}
        onClick={() => onChange(Math.min(max, value + 1))}
        className="h-10 w-10 grid place-items-center rounded-full text-primary transition-colors hover:bg-accent disabled:opacity-30">
        <Plus className="h-4 w-4" />
      </button>
    </div>
  );
}
